<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-12">
        <div class="row justify-content-center mb-4">
          <img src="@/assets/images/vuetify.png" width="20%" alt="" />
        </div>
        <div class="row justify-content-center">
          <h1>O que é?</h1>
        </div>

        <p class="lead">
          Vuetify é uma estrutura de IU completa construída sobre Vue.js. O
          objetivo do projeto é fornecer aos desenvolvedores as ferramentas de
          que precisam para criar experiências de usuário ricas e envolventes.
          Ao contrário de outros frameworks, Vuetify é projetado desde o início
          para ser fácil de aprender e gratificante de dominar com centenas de
          componentes cuidadosamente elaborados a partir da especificação de
          design de material.
        </p>

        <div class="row justify-content-center">
          <h1>Por que utilizar?</h1>
        </div>

        <p class="lead">
          Vuetify é desenvolvido com cada componente meticulosamente elaborado
          para ser modular, responsivo e eficiente. Personalize seu aplicativo
          com recursos exclusivos e dinâmicos.
        </p>
        <p class="lead">
          O Vuetify tem um ciclo de desenvolvimento muito ativo e é corrigido
          semanalmente, respondendo a problemas e relatórios da comunidade em
          uma velocidade vertiginosa, permitindo que você obtenha correções de
          bugs e melhorias com mais frequência.
        </p>

        <div class="col-sm-12 mt-5">
          <div class="row justify-content-center">
            <h1>Onde baixar?</h1>
          </div>
          <p class="lead">
            Você pode realizar o download do Vuetify no site oficial ->
            <a target="_blank" href="https://vuetifyjs.com/en/"
              >https://vuetifyjs.com/en/</a
            >. Lá você também pode encontrar tutoriais de aplicações simples,
            integrações de componentes e muito mais.
          </p>
        </div>
        <div class="col-sm-12 mt-5">
          <div class="row justify-content-center mb-4">
            <h1>Recursos e Componentes</h1>
          </div>

          <div class="row justify-content-center mb-4">
            <h3>Tabelas</h3>
          </div>
          <p class="lead">
            O componente de tabela é usado para exibir dados tabulares. Os
            recursos incluem classificação, pesquisa, paginação, edição de
            conteúdo e seleção de linha.
          </p>
          <div class="row justify-content-center mb-4">
            <img
              class="img-shadow"
              src="@/assets/images/table.png"
              width="60%"
              alt=""
            />
          </div>

          <div class="row justify-content-center mb-4">
            <h3>Sistema de Grid</h3>
          </div>
          <p class="lead">
            Vuetify vem com um sistema de grade de 12 pontos construído usando
            flexbox. A grade é usada para criar layouts específicos dentro do
            conteúdo de um aplicativo. Ele contém 5 tipos de pontos de
            interrupção de mídia que são usados ​​para direcionar tamanhos de
            tela ou orientações específicas, xs, sm, md, lg e xl.
          </p>
          <div class="row justify-content-center mb-4">
            <img
              class="img-shadow"
              src="@/assets/images/grid-system.png"
              width="60%"
              alt=""
            />
          </div>

          <div class="row justify-content-center mb-4">
            <h3>Calendário</h3>
          </div>
          <p class="lead">
            O componente de calendário é usado para exibir informações em uma
            exibição diária, semanal, mensal ou de categoria.
          </p>
          <div class="row justify-content-center mb-4">
            <img
              class="img-shadow"
              src="@/assets/images/calendar.jpeg"
              width="60%"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="text-center mt-5">
      <base-button type="primary" class="my-4" @click="scrollTop"
        >Voltar ao topo</base-button
      >
    </div>
  </div>
</template>

<script>
import { scrollTop } from "@/global";

export default {
  name: "vuetify-article",
  methods: { scrollTop: scrollTop },
};
</script>

<style>
.img-shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>